import React from 'react';
import Skeleton from 'react-loading-skeleton';

const LeaderboardItemLoader = () => (
  <div className="flex items-center gap-[10px] bg-gray-50 rounded-lg p-[12px]">
    <Skeleton circle width={24} height={24} />
    <Skeleton circle width={40} height={40} />
    <div className="flex-1">
      <Skeleton width="90%" height={16} />
    </div>
    <Skeleton width={24} height={16} />
  </div>
);

export default LeaderboardItemLoader;
